<script setup lang="ts">
defineProps({
    isSolid: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <svg
        v-if="isSolid"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        class="fill-current"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.25 12C2.25 6.61522 6.61522 2.25 12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12ZM13.6277 8.08328C12.7389 7.30557 11.2616 7.30557 10.3728 8.08328C10.0611 8.35604 9.58723 8.32445 9.31447 8.01272C9.04171 7.701 9.0733 7.22717 9.38503 6.95441C10.8394 5.68186 13.1611 5.68186 14.6154 6.95441C16.1285 8.27835 16.1285 10.4717 14.6154 11.7956C14.3588 12.0202 14.0761 12.2041 13.778 12.3484C13.1018 12.6756 12.7502 13.1222 12.7502 13.5V14.25C12.7502 14.6642 12.4144 15 12.0002 15C11.586 15 11.2502 14.6642 11.2502 14.25V13.5C11.2502 12.221 12.3095 11.3926 13.1246 10.9982C13.3073 10.9098 13.4765 10.799 13.6277 10.6667C14.4577 9.9404 14.4577 8.8096 13.6277 8.08328ZM12 18C12.4142 18 12.75 17.6642 12.75 17.25C12.75 16.8358 12.4142 16.5 12 16.5C11.5858 16.5 11.25 16.8358 11.25 17.25C11.25 17.6642 11.5858 18 12 18Z"
        />
    </svg>
    <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        class="fill-current"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM13.463 8.27142C12.6685 7.57619 11.332 7.57619 10.5374 8.27142C10.1218 8.6351 9.49001 8.59299 9.12633 8.17735C8.76265 7.76171 8.80477 7.12995 9.2204 6.76627C10.769 5.41124 13.2315 5.41124 14.7801 6.76627C16.407 8.18981 16.407 10.5602 14.7801 11.9837C14.5058 12.2237 14.2042 12.4198 13.887 12.5734C13.601 12.7118 13.3581 12.8877 13.1987 13.0699C13.0443 13.2463 13.0002 13.3878 13.0002 13.5V14.25C13.0002 14.8023 12.5525 15.25 12.0002 15.25C11.4479 15.25 11.0002 14.8023 11.0002 14.25V13.5C11.0002 12.0708 12.1775 11.1788 13.0157 10.7731C13.1791 10.694 13.3295 10.5955 13.463 10.4786C14.1793 9.85186 14.1793 8.89814 13.463 8.27142ZM11 17.25C11 16.6977 11.4477 16.25 12 16.25H12.0075C12.5598 16.25 13.0075 16.6977 13.0075 17.25V17.2575C13.0075 17.8098 12.5598 18.2575 12.0075 18.2575H12C11.4477 18.2575 11 17.8098 11 17.2575V17.25Z"
        />
    </svg>
</template>
